export const today = new Date();

export const characterArray = [
  "soft",
  "medium",
  "firm",
  "aniline",
  "semi-aniline",
  "pigment",
];
export const finishArray = ["aniline", "semi-aniline", "pigment"];
export const featureArray = [
  "perforation",
  "antique",
  "tumbled",
  "glazed",
  "two-tone",
  "distressed",
  "patent",
  "matte",
  "metallic",
  "embossed",
  "fracture",
  "waxy",
  "oily",
  "pull-up",
  "brush-off",
  "textured",
  "hair-cell",
];
export const availabilityArray = [
  "waterproof",
  "non-wicking",
  "metallic",
  "multi substrate",
  "color fast",
  "custom design",
];
export const texturedArray = [
  "natural",
  "exotic",
  "silk",
  "industrial",
  "woven",
  "3D custom",
];
export const sustainablityArray = ["kind", "common", "neutral", "low waste"];
export const typeArray = ["cowhide", "split", "goat", "synthetic"];
export const subTypeArray = [
  {
    cowhide: ["full-grain", "corrected", "nubuck", "flesh-out"],
    split: ["suede", "finished", "coated"],
    goat: ["finished"],
    synthetic: ["microfiber", "textile", "TPU"],
  },
];
export const statusArray = [
  "commercial",
  "development",
  "concept",
  "hidden",
  "error",
];
export const DESIGNER_HIDDEN_STATUSES = ["hidden", "error"];

const FIRMNESS_TAGS = new Set(characterArray.slice(0, 3));

function isFirmnessTag(value) {
  const base = String(value || "")
    .trim()
    .toLowerCase()
    .replace(/\s+temper$/, "");
  return FIRMNESS_TAGS.has(base);
}

export function formatCharacterLabels(character) {
  const list = Array.isArray(character) ? character : [];
  return list
    .slice(0, 2)
    .map((item) => {
      const value = String(item || "").trim();
      if (!value) {
        return "";
      }
      if (isFirmnessTag(value) && !/\btemper\b/i.test(value)) {
        return `${value} temper`;
      }
      return value;
    })
    .filter(Boolean);
}

export function isDesignerHiddenStatus(status) {
  return DESIGNER_HIDDEN_STATUSES.includes(
    String(status || "").trim().toLowerCase(),
  );
}

export function pickCatalogMaterial(
  matches,
  { id, hideDesignerStatuses = false } = {},
) {
  const visible = (Array.isArray(matches) ? matches : []).filter((item) =>
    hideDesignerStatuses ? !isDesignerHiddenStatus(item?.status) : true,
  );

  if (id != null && id !== "") {
    const exact = visible.find((item) => String(item.id) === String(id));
    if (exact) {
      return exact;
    }
  }

  if (visible.length === 0) {
    return null;
  }

  return [...visible].sort((a, b) => {
    const views = (Number(b.view_count) || 0) - (Number(a.view_count) || 0);
    if (views !== 0) {
      return views;
    }
    return (Number(a.id) || 0) - (Number(b.id) || 0);
  })[0];
}

export const substrateArray = ["leather", "synthetic", "multi"];
